import { render, staticRenderFns } from "./conjuntos.vue?vue&type=template&id=08fddf87&scoped=true"
import script from "./conjuntos.vue?vue&type=script&lang=js"
export * from "./conjuntos.vue?vue&type=script&lang=js"
import style0 from "./conjuntos.vue?vue&type=style&index=0&id=08fddf87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fddf87",
  null
  
)

export default component.exports